/*
 * MDB shim for MDBCollapse
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Pipeline/MonthGlance.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 */

import MUICollapse from "@mui/material/Collapse";

export default function MDBCollapse({ children, isOpen, ...rest }) {
    return (
        <MUICollapse in={Boolean(isOpen)} timeout="auto" {...rest}>
            {children}
        </MUICollapse>
    );
}
